<template>
  <div>
    <div class="list-item" v-for="audio in audioArr">
      <audio class="audioplayer"
             :src="audio.url"
             preload="metadata"
             controls="controls"></audio>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import AudioPlayer from '@packages/components/audioplayer/audioplayer'
  export default {
    data () {
      return {
        audioArr: [{'url': 'http://media.winbaoxian.com/learning/audio/2016/04/20/212402430.mp3'}]
      }
    },
    mounted: function () {
      var self = this;
      self.$nextTick(function () {
        var elements = document.querySelectorAll('.audioplayer');
        for (var i = 0; i < elements.length; i++) {
          // eslint-disable-next-line
          new AudioPlayer(elements[i], {
            index: i,
            autoplay: true
          });
        }
      });
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Audio.vue